import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, ZapIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-brand-navy text-white pt-20 pb-32 overflow-hidden" data-id="element-62">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-63"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-64">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-65">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-66">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-emerald/20 text-brand-emerald text-sm font-semibold mb-6" data-id="element-67">
              <ZapIcon size={16} data-id="element-68" />
              <span data-id="element-69">Acceso Instantáneo • Actualizaciones de Por Vida</span>
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-extrabold leading-tight mb-6" data-id="element-70">
              Acceso Instantáneo a +3700 Libros Digitales:{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-emerald to-teal-400" data-id="element-71">
                Domina Finanzas, Negocios, Salud y Crecimiento Personal
              </span>
            </h1>
            <p className="text-lg sm:text-xl text-gray-300 mb-8 font-medium" data-id="element-72">
              La biblioteca digital definitiva para mentes ambiciosas, por una
              fracción de su costo.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-73">
              <a href="#pricing" className="inline-flex justify-center items-center px-8 py-4 text-lg font-bold rounded-lg text-white bg-brand-orange hover:bg-orange-600 transition-colors shadow-[0_0_20px_rgba(249,115,22,0.4)] hover:shadow-[0_0_30px_rgba(249,115,22,0.6)] relative overflow-hidden group" data-id="element-74">
                <span className="relative z-10" data-id="element-75">Desbloquear Mi Biblioteca</span>
                <motion.div className="absolute inset-0 bg-white opacity-20" animate={{
                x: ['-100%', '100%']
              }} transition={{
                repeat: Infinity,
                duration: 1.5,
                ease: 'linear'
              }} data-id="element-76" />
              </a>
            </div>

            <div className="flex flex-wrap gap-4 text-sm text-gray-400" data-id="element-77">
              <div className="flex items-center gap-1.5" data-id="element-78">
                <CheckCircleIcon size={16} className="text-brand-emerald" data-id="element-79" />
                <span data-id="element-80">+3,700 libros</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-81">
                <CheckCircleIcon size={16} className="text-brand-emerald" data-id="element-82" />
                <span data-id="element-83">Entrega instantánea</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-84">
                <CheckCircleIcon size={16} className="text-brand-emerald" data-id="element-85" />
                <span data-id="element-86">Acceso de por vida</span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-87">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-gray-800 transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-88">
              <img src="https://cdn.magicpatterns.com/uploads/grGdJvMrBYcYPB9xMbXjkb/librosfina-dOqyg7QN1EFo2V22.jpg" alt="Mega pack de libros digitales de finanzas y negocios" className="w-full h-auto object-cover" data-id="element-89" />
              <div className="absolute top-4 right-4 bg-brand-red text-white font-black px-4 py-2 rounded-lg transform rotate-12 shadow-lg text-xl border-2 border-white" data-id="element-90">
                MEGA PACK
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -z-10 -top-10 -right-10 w-40 h-40 bg-brand-emerald rounded-full blur-3xl opacity-20" data-id="element-91"></div>
            <div className="absolute -z-10 -bottom-10 -left-10 w-40 h-40 bg-brand-orange rounded-full blur-3xl opacity-20" data-id="element-92"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}